<div class="general_colum" *ngIf="showFormByUser==false">
  <div class="row mt-4">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 mt-4">
      <p class="text_headerr" style="width: 100%;">Filtro Consulta de Trámites por Numero de Documento</p>
      <p class="text_header">Licencia de Seguridad y Salud en el Trabajo.</p>
    </div>
  </div>

  <form [formGroup]="validatorForm">
    <div class="row mt-3" style="margin-top: -40px;">
      <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
        <p style="font-size: 16px; font-weight: normal;margin-top: 20px;position: relative;">No. Documento Solicitante: </p>
        <div class="general_date">
          <input style="padding: 8px; margin-top: -12px;" type="text" class="form-control search" id="identificationNumber" placeholder="No. Documento Solicitante" formControlName="identificationNumber"
          />
        </div>
      </div>
      <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
        <div class="colum_filter_select" style="margin-left:-4px; margin-top: 55px;">
          <select class="form-select option" aria-label="Default select
              example" formControlName="pageSize" (change)="changeDataTable()">
            <option *ngFor="let item of pageSizeOptions" [value]="item">Mostrar
              {{item}} registros</option>
          </select>
        </div>
      </div>
      <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
        <div class="colum_search" style="margin-top: 55px;">
          <div class="form-group type">
            <input style="padding: 8px;" type="text" class="form-control search searching" id="search" placeholder="Palabras claves" formControlName="textToSearch" />
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
        <div class="general_date_button" style="margin-top: 55px;">
          <button class="btn-success btn btn_search btn_block btn_pull" (click)="changeDataTable()">Consultar <i class="fa-solid fa-magnifying-glass" style="margin-left: 10px;"></i></button>
        </div>
      </div>
    </div>
  </form>

  <div class="row">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <div class="alert_header mt-4">
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          <strong>¡Apreciado Usuario!</strong>
          <p class="text-justify mt-3 alert_p">
            La siguiente consulta tiene como filtro de búsqueda el Número de Documento del solicitante o NIT
            quien está registrado como persona natural o jurídica en el sistema Ventanilla Única de Trámites y
            Servicios de la Secretaría Distrital de Salud. Favor ingresar el número de documento sin
            separadores, espacios y/o puntos.
          </p>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <div class="table-responsive">
        <table class="table" aria-describedby="mydesc">
         <thead>
          <tr>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>ID trámite</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('id', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('id', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Identificación</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('identificationNumber', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('identificationNumber', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Nombres y Apellidos</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('fullName', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('fullName', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Tipo Trámite</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('process', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('process', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Fecha radicación</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('registrationDate', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('registrationDate', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Estado trámite</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('status', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('status', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Fecha Estado</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('dateTracking', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('dateTracking', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Tiempo de respuesta</div>
                <div class='icon-right'>
                  <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('responseTime', 'up')"></span>
                  <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('responseTime', 'down')"></span>
                </div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Acciones</div>
              </div>
            </th>
          </tr>
         </thead>
          <tbody>
            <tr *ngFor="let item of tableFilter let i= index ">
              <td>{{item.filedNumber}}</td>
              <td>{{item.identificationNumber}}</td>
              <td>{{item.fullName}}</td>
              <td>{{item.process}}</td>
              <td>{{item.registrationDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td>{{item.status}}</td>
              <td>{{item.dateTracking | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td id="color_{{i}}">{{changeColor(item.responseTime,i)}}</td>
              <td class="text-justify">
                <a (click)="getTramiteActual(item.id)"><span class="govco-readme">Ver</span> </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="colum_paginator">
        <mat-paginator class="paginator" [hidePageSize]="true" [length]="totalRequests"
                       [pageSize]="validatorForm.get('pageSize').value" (page)="cambiarpagina($event)"> </mat-paginator>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 col-md-8">
    <app-info-tramite [tramiteActual]="tramiteSeleccionado" [isOnlyReadTramite]="true" *ngIf="showFormByUser==true"></app-info-tramite>
  </div>
</div>

<div *ngIf="showFormByUser==true">
  <br><br>
  <button type="button" class="btn-govco fill-btn-govco"
          style="margin-right: 10px"
          (click)="cancelFrm()">Volver
  </button>
</div>
